/* @flow */

import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {TrialGatheringLayout} from 'shells/trial-gathering/trial-gathering-layout';

import {TinyIntroRadioButtons} from '../../fields/tiny-intro-radio-buttons';

import {ANIMATION_SRC, NUMBER_OF_STEPS, TEAM_SIZE_OPTIONS} from '../consts';

type Props = {|
    onBack: () => void,
    onNext: () => void,
    teamSize: ?string,
    setTeamSize: (teamSize: ?string) => void,
    handleStepViewed: () => void,
|};

export function TeamSize(props: Props) {
    const [teamSizeError, setTeamSizeError] = React.useState<?string>(null);

    React.useEffect(() => {
        props.handleStepViewed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (props.teamSize !== null) {
            setTeamSizeError(null);
        }
    }, [props.teamSize]);

    const handleNext = () => {
        if (props.teamSize === null) {
            setTeamSizeError('Please select a team size');
        } else {
            props.onNext();
        }
    };

    return (
        <TrialGatheringLayout
            prompt='How big is your team?'
            currentStep={3}
            totalSteps={NUMBER_OF_STEPS}
            animation={<Rive src={ANIMATION_SRC.TEAM_SIZE} />}
            animationBackgroundColor='tagOrangeDk'
            onBack={props.onBack}
            onNext={handleNext}
        >
            <TinyIntroRadioButtons
                title=''
                options={TEAM_SIZE_OPTIONS}
                variant='controlled'
                name='radiobuttons'
                value={props.teamSize}
                onChange={props.setTeamSize}
                error={teamSizeError}
                isRequired={true}
            />
        </TrialGatheringLayout>
    );
}
